export const LEADER_SUBJECT_LABEL = 'Sujet leader';
export const DELETE_LABEL = 'Supprimer';
export const SEE_ARTICLE_LABEL = 'Consulter';
export const MENU_WIDTH = 48;
